module.exports = __webpack_public_path__ + "static/media/computing-programming-language-svgrepo-com.95bd2521.svg";